module.exports = {
  // 后台登录token错误
  ADMIN_TOKEN_ERR: 401,
  SUCCESS:0,
}



// WEBPACK FOOTER //
// ./src/util/error.js